module.exports = "<section class=\"detial-section\" id=\"detail\" >\n  <div id=\"data\">\n    \n  </div>\n  \n  <div id=\"canvas-contianer\" style=\"position: relative; height:100%; width:100%\">\n    <canvas id=\"chart\"></canvas>\n  </div>\n\n  <div class=\"contianer\">\n    <div id=\"related-data\" class=\"row\" >\n\n    </div>\n  </div>\n    \n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/detial-view/detial-view.component.html
// module id = 317
// module chunks = 2